"use strict";

exports.__esModule = true;
exports.default = exports.ErrNotAuthed = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DEFAULT_CONFIG = {
  timeout: 30000,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 400;
  }
};
var ErrNotAuthed = new Error('Invalid Auth Token');
/**
 * @callback statusCallback
 * @param {Object} request the original XMLHttpRequest sent to the server.
 * @param {Object} response the response object that came back from the server.
 * @returns {?Promise} a promise to be returned to axios.
 */

/**
 * @callback requestHook
 * @param {Object} config the request config used by axios to resolve request.
 * @returns {Promise} a promise which either resolves to a request config or rejected with an error.
 */

/**
 * @class Francis - wrapper around axios
 */

exports.ErrNotAuthed = ErrNotAuthed;

var Francis = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Object} [config] An Axios config for overriding any default axios functionality
   */
  function Francis(config) {
    this.config = Object.assign({}, DEFAULT_CONFIG, config);
    this.axios = _axios.default.create(this.config);
    this.statusCallbacks = {};
    this.requestHooks = [];
    this.authToken = null;
    this.init();
  }
  /**
   * @method init initializes stuff, such as adding the axios interceptors.
   */


  var _proto = Francis.prototype;

  _proto.init = function init() {
    this.axios.interceptors.request.use(this.requestInterceptor.bind(this), function (error) {
      return Promise.reject(error);
    });
    this.axios.interceptors.response.use(undefined, this.errorResponseInterceptor.bind(this));
  };
  /**
   * @function requestInterceptor applies auth and token logic to all requests.
   */


  _proto.requestInterceptor = function requestInterceptor(config) {
    // Check auth first
    if (config.useBearerToken) {
      if (!this.authToken) {
        return Promise.reject(ErrNotAuthed);
      }
      /* eslint-disable-next-line */


      config.headers.Authorization = "Bearer " + this.authToken;
    } // Run through all requestHooks


    if (this.requestHooks.length) {
      return Promise.all(this.requestHooks).then(function (configs) {
        var newConfig = configs.reduce(function (a, v) {
          return Object.assign({}, a, v);
        }, config);
        return Promise.resolve(newConfig);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    } else {
      // Return resolved config
      return config;
    }
  };
  /**
   * @function errorResponseInterceptor handles errors coming from responses. Runs any applicable status callbacks.
   */


  _proto.errorResponseInterceptor = function errorResponseInterceptor(error) {
    if (error.response) {
      var status = error.response.status;
      var cb = this.statusCallbacks[status];
      var prom = null;

      if (cb && typeof cb === 'function') {
        prom = cb(error.request, error.response);
      }

      if (prom !== null && prom !== undefined) {
        return prom;
      }
    }

    return Promise.reject(error);
  };

  _proto.setAuthToken = function setAuthToken(token) {
    this.authToken = token;
  };
  /**
   * @method addRequestHook sets a callback function to be called before a request is resolved.
   * @param {requestHook} cb the function to be called before the request is resolved.
   */


  _proto.addRequestHook = function addRequestHook(cb) {
    this.requestHooks.push(cb);
  };
  /**
   * @method setStatusCallback sets a callback function to be called whenever a response comes back with the cooresponding status.
   * @param {Number} code the status code the given function should handle.
   * @param {statusCallback} cb the function to handle the given status code.
   */


  _proto.setStatusCallback = function setStatusCallback(code, cb) {
    this.statusCallbacks[code] = cb;
  };
  /**
   * @method request proxies calls to axios's request method.
   * @returns {Promise} A Promise containing the response of the request
   */


  _proto.request = function request() {
    var _this$axios;

    return (_this$axios = this.axios).request.apply(_this$axios, arguments);
  };
  /**
   * @method get proxies calls to axios's get method.
   * @returns {Promise} A Promise containing the response of the get request
   */


  _proto.get = function get() {
    var _this$axios2;

    return (_this$axios2 = this.axios).get.apply(_this$axios2, arguments);
  };
  /**
   * @method post proxies calls to axios's post method.
   * @returns {Promise} A Promise containing the response of the post request
   */


  _proto.post = function post() {
    var _this$axios3;

    return (_this$axios3 = this.axios).post.apply(_this$axios3, arguments);
  };
  /**
   * @method put proxies calls to axios's put method.
   * @returns {Promise} A Promise containing the response of the put request
   */


  _proto.put = function put() {
    var _this$axios4;

    return (_this$axios4 = this.axios).put.apply(_this$axios4, arguments);
  };
  /**
   * @method del proxies calls to axios's del method.
   * @returns {Promise} A Promise containing the response of the del request
   */


  _proto.del = function del() {
    var _this$axios5;

    return (_this$axios5 = this.axios).delete.apply(_this$axios5, arguments);
  };

  return Francis;
}();

var _default = new Francis();

exports.default = _default;